import { useEffect, useMemo } from "react"
import { isEqual } from "lodash-es"
import { useDispatch, useSelector } from "react-redux"
import { getOrganizationId } from "reduxSlices/currentSettingsSlice"
import { setFilterSelections, settingsToPersist } from "reduxSlices/reportIndexSlice"
import { currentUserId as getCurrentUserId } from "reduxSlices/sessionSlice"
import { LocalStoragePersistence } from "utils/Persistence"

const SETTINGS_PERSISTENCE_PROPERTY = "settings"

const useReportIndexSettings = ({ persistence = LocalStoragePersistence } = {}) => {
  const dispatch = useDispatch()

  const organizationId = useSelector(getOrganizationId)
  const currentUserId = useSelector(getCurrentUserId)
  const reportIndexSettingsToPersist = useSelector(settingsToPersist, isEqual)

  const key = useMemo(() => (
    `report-index-settings-org-${organizationId}-user-${currentUserId}`
  ), [currentUserId, organizationId])

  // On load, get persisted filter selections and pass them to redux
  useEffect(() => {
    const persistedSettings = persistence.lookup({ key, property: SETTINGS_PERSISTENCE_PROPERTY })

    dispatch(setFilterSelections(persistedSettings))
  }, [dispatch, key, persistence])

  // Keep filter selections up to date in local storage
  useEffect(() => {
    persistence.persist({ key, property: SETTINGS_PERSISTENCE_PROPERTY, value: reportIndexSettingsToPersist })
  }, [reportIndexSettingsToPersist, key, persistence])
}

export default useReportIndexSettings
